(function () {  })();
jQuery(document).on("click",".wholesell_prod_load", function(){
  var current_page = Number (jQuery(this).parent().attr("data-current"));
  if(window.screen.width > 798 ){
    var next = current_page+3;
    jQuery(".wp_info-"+(current_page+2) ).show();
    jQuery(".wp_info-"+(current_page+3) ).show();
  }
  else{
    var next = current_page+1;
    jQuery(".wp_info-"+(current_page+1) ).show();
  }
  if(jQuery(".wp_info-"+(next+1) ).length > 0){
     jQuery(this).parent().attr("data-current",next);
  }
  else{
  jQuery(this).parent().hide();
  } 
});

// on click of thumbnail variant change 
jQuery(document).ready(function(){
  jQuery(".product-gallery__thumbnail").click(function(){
    var connectedVariant = jQuery(this).attr("data-variant");
    console.log(connectedVariant);
    jQuery(connectedVariant).children("input").click();
  });

  // jQuery(".product-gallery__main button.flickity-button.flickity-prev-next-button").click(function(){
  //   var selectedVariantThumbnail = $(".product-gallery__thumbnail.is-nav-selected");    
  //   jQuery(selectedVariantThumbnail).click();
  // });
  //   jQuery(".product-gallery__image").click(function(){
  //   var selectedVariantThumbnail = $(".product-gallery__thumbnail.is-nav-selected");    
  //   jQuery(selectedVariantThumbnail).click();
  // });
   
  
});
 

// jQuery(document).on("click",".wholesell_prod_load-mobile", function(){
//   var mobilePage = Number (jQuery(this).parent().attr("data-mobilecurrent")) + 1;
//   var lastCount = jQuery(".wp_info-mobile-"+mobilePage ).find('span').data('last-count');
//   jQuery(".wp_info-mobile-"+mobilePage ).show();
//   if(lastCount == mobilePage ){
//     jQuery(this).parent().hide();
//   }
//   if(jQuery(".wp_info-mobile-"+mobilePage ).length > 0){
//      jQuery(this).parent().attr("data-mobilecurrent",mobilePage);
//   }
//   else{
//     jQuery(this).parent().hide();
//   }
// });app